export default function TechFetchIco() {
  return (
    <svg
      width="26"
      height="38"
      viewBox="0 0 26 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.6408 12.7542L25.6514 12.7495C25.5292 12.3509 25.3117 11.9669 24.9387 11.6654C23.5701 10.5582 3.13846 0.458781 3.13846 0.458781C3.13846 0.458781 0.593543 -0.483697 0.241943 2.39411C0.241943 2.39411 14.8812 11.0381 16.6899 15.9237C18.4999 20.8094 12.9799 36.9132 12.9799 36.9132C15.1177 38.8723 16.4387 36.5037 16.4387 36.5037C16.4387 36.5037 25.4019 15.5483 25.7229 13.8179C25.7957 13.4346 25.7487 13.0796 25.6408 12.7542Z"
        fill="#E75300"
      />
    </svg>
  );
}
